import { Link } from "react-router-dom";
import { Lock, Music4 } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  const links = [
    { path: "/", label: "Home" },
    { path: "/store", label: "Store" },
    { path: "/reviews", label: "Reviews" },
    { path: "/licensing", label: "Licensing" },
    { path: "/contact", label: "Contact" },
  ];

  return (
    <footer className="border-t border-border mt-20 px-6 lg:px-8 py-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-center md:justify-between gap-8">
        <div>
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-xl bg-primary/20 flex items-center justify-center">
              <Music4 className="w-5 h-5 text-primary" />
            </div>
            <span className="font-heading font-black text-lg">
              <span className="italic text-primary">Truu</span> Production Lane
            </span>
          </div>
          <p className="text-sm text-muted-foreground mt-3 max-w-xs">
            Premium beats for artists who want to stand out. Instant delivery, royalty-free licensing.
          </p>
        </div>

        <nav className="flex flex-wrap gap-x-6 gap-y-2">
          {links.map((l) => (
            <Link
              key={l.path}
              to={l.path}
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
              data-testid={`footer-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>
      </div>

      <div className="max-w-7xl mx-auto mt-10 pt-6 border-t border-border/50 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-muted-foreground">
          © {year} Truu Production Lane. All rights reserved.
        </p>
        <Link
          to="/admin/login"
          className="inline-flex items-center gap-1.5 text-xs text-muted-foreground/70 hover:text-primary transition-colors"
          data-testid="footer-admin-link"
        >
          <Lock className="w-3 h-3" />
          Admin
        </Link>
      </div>
    </footer>
  );
}
